import React, { useState, createContext } from 'react';
export const ModalManagerStateContext = createContext({});
export const ModalManagerSetContext = createContext(() => { });
export const ModalManagerProvider = (props) => {
    const { children, defaultModals = {} } = props;
    const [modals, setModals] = useState(defaultModals);
    return (React.createElement(ModalManagerStateContext.Provider, { value: modals },
        React.createElement(ModalManagerSetContext.Provider, { value: setModals }, children)));
};
